import { DeleteTwoTone } from "@ant-design/icons";
import { message, Popconfirm } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { deleteCapability, fetchCapabilities } from "../../../redux/Capabilities/actions";

export const DeleteCapability = ({ item }) => {
    const dispatch = useDispatch();

    const deleteCapability_fun = () => {
        dispatch(deleteCapability(item._id)).then(() => {
            dispatch(fetchCapabilities());
        });
        message.success("Deleted");
    };

    const confirm = () => {
        deleteCapability_fun();
    };

    const cancel = () => {};

    return (
        <Popconfirm
            onConfirm={confirm}
            onCancel={cancel}
            title="Are you sure you want to delete?"
            okText="Yes"
            cancelText="No"
        >
            <DeleteTwoTone twoToneColor="red" key="delete" />
        </Popconfirm>
    );
};

export default DeleteCapability;
